import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("hreye_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("hreye_token");
      localStorage.removeItem("hreye_user");
      const path = window.location.pathname;
      const onAuthPage = path.startsWith("/login") || path.startsWith("/admin/login") || path.startsWith("/signup") || path.startsWith("/reset-password");
      if (!onAuthPage) {
        window.location.href = "/login";
      }
    }
    // Seat limit hit — surface a structured event any page can listen to
    if (err.response?.status === 402 && err.response?.data?.detail?.error === "seat_limit_reached") {
      try {
        window.dispatchEvent(new CustomEvent("hreye:seat-limit-reached", { detail: err.response.data.detail }));
      } catch {}
    }
    return Promise.reject(err);
  }
);

export default api;
